import { createSlice } from "@reduxjs/toolkit";
import { getCompanyProfile, updateCompanyProfile } from "../thunks/companyThunks";
import { removeTeamMemberClient } from "../thunks/teamMemberClientThunks";

const initialState = {
  companyProfile: {
    data: null,
    loading: false,
    error: null,
  },
};

const companySlice = createSlice({
  name: "company",
  initialState,
  extraReducers: (builder) => {
    // Get Company Profile
    builder
      .addCase(getCompanyProfile.pending, (state) => {
        state.companyProfile.loading = true;
        state.companyProfile.error = null;
      })
      .addCase(getCompanyProfile.fulfilled, (state, action) => {
        state.companyProfile.loading = false;
        state.companyProfile.data = action.payload.data;
      })
      .addCase(getCompanyProfile.rejected, (state, action) => {
        state.companyProfile.loading = false;
        state.companyProfile.error = action.payload || "Failed to fetch company profile";
        state.companyProfile.data = null;
      });

    // Update Company Profile
    builder
      .addCase(updateCompanyProfile.pending, (state) => {
        state.companyProfile.loading = true;
        state.companyProfile.error = null;
      })
      .addCase(updateCompanyProfile.fulfilled, (state, action) => {
        state.companyProfile.loading = false;
        state.companyProfile.data = action.payload.data;
      })
      .addCase(updateCompanyProfile.rejected, (state, action) => {
        state.companyProfile.loading = false;
        state.companyProfile.error = action.payload || "Failed to update company profile";
      });

    // Handle team member removal to update company profile
    builder
      .addCase(removeTeamMemberClient.fulfilled, (state, action) => {
        // Remove the team member from company profile data if it exists
        try {
          if (state.companyProfile.data && state.companyProfile.data.teamMembers) {
            if (Array.isArray(state.companyProfile.data.teamMembers)) {
              state.companyProfile.data.teamMembers = state.companyProfile.data.teamMembers.filter(
                (member) => member.id !== action.payload.memberId
              );
              console.log('Updated company profile team members after removal');
            } else {
              console.warn('Company profile teamMembers is not an array:', state.companyProfile.data.teamMembers);
              state.companyProfile.data.teamMembers = [];
            }
          }
        } catch (error) {
          console.error('Error updating company profile team members:', error);
        }
      });
  },
});

export default companySlice.reducer;
